import {
  Create,
  SimpleForm,
  TextInput,
  SelectInput,
  BooleanInput,
  required,
  useNotify,
} from 'react-admin';
import { useEffect, useState } from 'react';
import { Alert } from '@mui/material';

const deviceChoices = [
  { id: 'ios', name: 'iOS' },
  { id: 'android', name: 'Android' },
  { id: 'web', name: 'Web' },
];

const NotificationCreate = (props: any) => {
  const [error, setError] = useState<string | null>(null);
  const notify = useNotify();

  useEffect(() => {
    const handleError = (e: any) => {
      setError(
        'Notifications API is not available yet. This feature will be enabled once the backend is ready.'
      );
    };
    window.addEventListener('unhandledrejection', handleError);
    return () => window.removeEventListener('unhandledrejection', handleError);
  }, []);

  if (error) {
    return <Alert severity="info">{error}</Alert>;
  }

  return (
    <Create {...props}>
      <SimpleForm>
        <TextInput
          source="token"
          label="FCM Token"
          validate={required()}
          fullWidth
          multiline
          rows={3}
        />
        <TextInput
          source="userId"
          label="User ID"
          validate={required()}
          fullWidth
        />
        <SelectInput
          source="device"
          label="Device Type"
          choices={deviceChoices}
          validate={required()}
          fullWidth
        />
        <BooleanInput
          source="isActive"
          label="Active"
          defaultValue={true}
        />
      </SimpleForm>
    </Create>
  );
};

export default NotificationCreate; 